import Vue from 'vue'

import Constants from './routes/Constants';
import Router from 'vue-router'
import Dashboard from './views/Dashboard'
import Settings from './views/settings/Settings'
import ManageAccount from './views/account/ManageAccount';

import user_public_routes from './routes/user_public'
import order_routes from './routes/orders'
import product_routes from './routes/products'
import CartIndex from "./views/cart/CartIndex";
import AppUtil from "./util/AppUtil";

Vue.use(Router);
Vue.prototype.$ROUTES = Constants;

const r = new Router({
    mode : 'history',
    routes : [
        {
            path : '/',
            name : Constants.DASHBOARD,
            component : Dashboard,
            meta : {
                title : 'Dashboard',
            }
        },
        {
            path : '/settings',
            name : Constants.SETTINGS,
            component : Settings,
            meta : {
                title : 'Settings',
            }
        },
        {
            path : '/account',
            name : Constants.ACCOUNT,
            component : ManageAccount,
            meta : {
                title : () => {
                    return 'Manage Your Account Settings';
                },
            }
        },
        {
            path : '/cart',
            name : Constants.CART,
            component : CartIndex,
            meta : {
                accessGuard : true,
            }
        },
    ]
        .concat(user_public_routes)
        .concat(order_routes)
        .concat(product_routes)
    ,
});

r.beforeEach((to, from, next) => {
    if(AppUtil.versionChangedReloadOnRouteChange){
        AppUtil.writeVersionToLocalStorage();
        window.localStorage.setItem(AppUtil.VERSION_CHANGED_RELOAD_REDIRECT_TO_PATH_KEY, to.fullPath);
        window.location.reload(true);
        return;
    }
    next();
});

r.afterEach((to) => {
    if(to.meta && to.meta.title){
        document.title = typeof to.meta.title === 'string' ? to.meta.title : to.meta.title(to);
    }
});

window.Router = r;

export default r;
